import * as React from 'react';
import { getSportClass, SportIconType } from 'eTip--common';

export interface ISportIconProps {
    type: SportIconType;
    className?: string;
}

export const SportIcon = (props: ISportIconProps) => {
    return (
        <div className={`sport-icon ${getSportClass(props.type, props.className)}`}>
        </div>
    );
};

export default SportIcon;



